module.exports = __webpack_public_path__ + "static/media/cr.74dd61b6.svg";